import { Dialog, Transition } from '@headlessui/react';
import React, { useRef, useState } from 'react'

interface Props {
    shareListOpen: boolean,
    setShareListOpen: (state: boolean) => void,
    isEvent: boolean
}

const ShareList: React.FC<Props> = ({ shareListOpen, setShareListOpen, isEvent }) => {
    const [isCopy, setIsCopy] = React.useState(false);
    const shareRef = useRef<HTMLUListElement>(null)
    const [isAlert, setIsAlert] = useState(false)

    const openAlert = () => {
        setIsAlert(true);

        setTimeout(() => {
            setIsAlert(false);
        }, 1500);
    };

    const onShareVK = () => {
        const path = window.location.href;
        setShareListOpen(false)

        window.open(
            `https://vk.com/share.php?url=${encodeURIComponent(
                path
            )}&comment=${encodeURIComponent(path)}`
        );
    }

    const onShareOK = () => {
        const path = window.location.href;
        setShareListOpen(false)

        window.open(
            `https://connect.ok.ru/offer?url=${encodeURIComponent(path)}`
        );
    }

    const onShareTG = () => {
        const path = window.location.href;
        setShareListOpen(false)
        window.open(`tg://msg_url?url=${encodeURIComponent(path)}`);
    }

    const onCopyClick = () => {
        openAlert()
        setShareListOpen(false)
        const path = window.location.href;
        if (!isCopy) {
            const $temp = document.createElement('input');
            $temp.value = path;
            document.body.appendChild($temp);
            $temp.select();
            document.execCommand('copy');
            $temp.remove();
            setIsCopy(true);
        }
    };

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (shareRef.current && !event.composedPath().includes(shareRef.current)) {
                setShareListOpen(false)
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <>
            <div className={`news-details__share-alert ${isAlert && 'news-details__share-alert_open'}`}>
                <div>
                    <p>Ссылка скопирована в буфер обмена!</p>
                </div>
            </div>
            <ul ref={shareRef} style={isEvent ? { right: 'unset', left: 0 } : {}} className={`news-details__share-list ${shareListOpen && 'news-details__share-list_open'}`}>
                <li onClick={onCopyClick} className="news-details__share-item link">
                    <svg width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.8861 19.8984L18.1896 21.5949C17.7441 22.0404 17.2153 22.3937 16.6332 22.6348C16.0512 22.8759 15.4274 23 14.7974 23C14.1674 23 13.5435 22.8759 12.9615 22.6348C12.3794 22.3937 11.8506 22.0404 11.4051 21.5949C10.5054 20.6952 10 19.475 10 18.2026C10 16.9303 10.5054 15.7101 11.4051 14.8104L13.1016 13.1139" stroke="#A9B4D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.1895 8.0244L19.8859 6.33087C20.7922 5.46409 22.0017 4.98649 23.2556 5.00029C24.5095 5.01409 25.7082 5.51821 26.5951 6.40473C27.482 7.29125 27.9867 8.48973 28.001 9.74365C28.0154 10.9976 27.5383 12.2073 26.6719 13.1139L24.9754 14.8104" stroke="#A9B4D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14.7988 18.2034L23.2798 9.72095" stroke="#A9B4D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Скопировать ссылку
                </li>
                <li onClick={onShareVK} className="news-details__share-item vk">
                    <svg width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9679 19.1314C20.4754 19.1314 20.6828 18.8085 20.677 18.4036C20.6512 16.8787 21.272 16.0578 22.3928 17.1277C23.6327 18.3113 23.8894 19.1314 25.3951 19.1314H28.0617C28.735 19.1314 29 18.9246 29 18.6001C29 17.9136 27.8159 16.7022 26.8126 15.8129C25.4076 14.568 25.3418 14.5386 26.5518 13.0399C28.0525 11.1794 30.0158 8.79544 28.2792 8.79544H24.9618C24.3185 8.79544 24.2719 9.14146 24.0427 9.65691C23.2136 11.5238 21.6378 13.942 21.0395 13.5721C20.4137 13.1863 20.7003 11.6582 20.7478 9.38725C20.7603 8.78749 20.757 8.37625 19.7971 8.16307C19.2729 8.04773 18.7629 8 18.2896 8C16.3955 8 15.0889 8.75806 15.8314 8.8901C17.1405 9.12317 17.0147 11.8269 16.7097 12.9946C16.178 15.0277 14.1798 11.3846 13.3473 9.57021C13.1465 9.1343 13.0848 8.79544 12.3682 8.79544H9.65581C9.24582 8.79544 9 8.92272 9 9.20589C9 9.68475 11.4666 14.5513 13.8215 16.9774C16.118 19.3438 18.3879 19.1314 19.9679 19.1314Z" fill="#A9B4D1" />
                    </svg>
                    ВКонтакте
                </li>
                <li onClick={onShareOK} className="news-details__share-item ok">
                    <svg width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0513 5C16.4643 5 14.3672 7.09718 14.3672 9.6841C14.3672 12.2711 16.4643 14.3684 19.0513 14.3684C21.6383 14.3684 23.7354 12.2711 23.7354 9.6841C23.7354 7.09718 21.6383 5 19.0513 5ZM19.0513 11.6205C17.9819 11.6205 17.115 10.7535 17.115 9.68416C17.115 8.61479 17.9819 7.74786 19.0513 7.74786C20.1207 7.74786 20.9876 8.61479 20.9876 9.68416C20.9876 10.7535 20.1207 11.6205 19.0513 11.6205Z" fill="#A9B4D1" />
                        <path d="M20.7042 18.0954C22.5794 17.7134 23.7031 16.8254 23.7626 16.7777C24.3113 16.3376 24.3995 15.5361 23.9594 14.9873C23.5194 14.4385 22.7179 14.3504 22.169 14.7904C22.1574 14.7998 20.9589 15.7192 18.9869 15.7205C17.0149 15.7192 15.791 14.7998 15.7794 14.7904C15.2306 14.3504 14.4291 14.4385 13.9891 14.9873C13.549 15.5361 13.6371 16.3376 14.1859 16.7777C14.2461 16.826 15.4162 17.7372 17.344 18.1102L14.6573 20.9181C14.169 21.4245 14.1837 22.2307 14.6901 22.719C14.9372 22.9573 15.2558 23.0757 15.574 23.0757C15.9077 23.0757 16.2411 22.9454 16.491 22.6861L18.9869 20.0273L21.735 22.7034C22.2329 23.2005 23.0392 23.1997 23.5362 22.702C24.0331 22.2042 24.0325 21.3978 23.5347 20.9008L20.7042 18.0954Z" fill="#A9B4D1" />
                        <path d="M18.9868 15.7206C18.9852 15.7206 18.9883 15.7207 18.9868 15.7207C18.9853 15.7207 18.9883 15.7206 18.9868 15.7206Z" fill="#A9B4D1" />
                    </svg>
                    Одноклассники
                </li>
                <li onClick={onShareTG} className="news-details__share-item tg">
                    <svg width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7883 21.8344C24.0298 22.0054 24.341 22.0481 24.6185 21.9431C24.896 21.8374 25.1 21.6004 25.1615 21.3131C25.8133 18.2501 27.3943 10.4974 27.9875 7.71111C28.0325 7.50111 27.9575 7.28286 27.7925 7.14261C27.6275 7.00236 27.3988 6.96186 27.1948 7.03761C24.05 8.20161 14.3653 11.8354 10.4068 13.3001C10.1555 13.3931 9.99205 13.6346 10.0003 13.8994C10.0093 14.1649 10.1878 14.3951 10.445 14.4724C12.2203 15.0034 14.5505 15.7421 14.5505 15.7421C14.5505 15.7421 15.6395 19.0309 16.2073 20.7034C16.2785 20.9134 16.4428 21.0784 16.6595 21.1354C16.8755 21.1916 17.1065 21.1324 17.2678 20.9801C18.1798 20.1191 19.5898 18.7879 19.5898 18.7879C19.5898 18.7879 22.2688 20.7521 23.7883 21.8344ZM15.5308 15.3266L16.79 19.4801L17.0698 16.8499C17.0698 16.8499 21.935 12.4616 24.7085 9.96036C24.7895 9.88686 24.8008 9.76386 24.7333 9.67761C24.6665 9.59136 24.5435 9.57111 24.4513 9.62961C21.2368 11.6824 15.5308 15.3266 15.5308 15.3266Z" fill="#A9B4D1" />
                    </svg>
                    Телеграм
                </li>
            </ul>
        </>
    )
}

export default ShareList
